// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3Ntpm","fileDisabled":"File_fileDisabled__2SNTL"};